import { combineReducers } from "@reduxjs/toolkit";
import alarms from "./alarmParameters/alarmUXSlice";

export default combineReducers({
  alarms,
});